import { ReactNode } from "react";
import { Link as ReactRouterLink } from "react-router-dom";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AnyReactRouterLink: any = ReactRouterLink; // Fix for react version types mismatch

export const Link = (props: {
    to: string;
    "data-testid"?: string;
    children: ReactNode;
}) => {
    return (
        <AnyReactRouterLink to={props.to} data-testid={props["data-testid"]}>
            {props.children}
        </AnyReactRouterLink>
    );
};
